module.exports = __webpack_public_path__ + "img/antes_despues_240.cd559ddd.png";